



























































































































































































































































































































































































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
// @ts-ignore
import draggable from 'vuedraggable';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Auction, Lot, ApiError, Media } from '@/api';
import { snackModule } from '@/store';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import LotEdit from '@/components/admin/LotEdit.vue';
import DatePicker from '@/components/admin/DatePicker.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import MediaUpload from '@/components/admin/MediaUpload.vue';
import ImportLots from '@/components/admin/ImportLots.vue';
import { Route } from 'vue-router';
import { apiBase, apiNamespace } from '@/config';
import axios from 'axios';
import Cookies from 'js-cookie';

@Component({
  components: {
    draggable,
    AbstractTable,
    LotEdit,
    DatePicker,
    ConfirmDialog,
    MediaUpload,
    ImportLots,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  auction: Auction | null = null;
  auctionStatuses: Array<{ label: string; value: string }> = [
    { label: 'Coming Soon', value: 'future' },
    { label: 'Current', value: 'current' },
    { label: 'Past', value: 'past' },
  ];

  auctionPublic: boolean = true;

  mediaToDelete: Media[] = [];

  selectedLots: Lot[] = [];
  lotConfirmDialog: boolean = false;
  lotAddEdit: boolean = false;
  lotToEdit: Lot | null = null;
  lotSearch: string = '';
  lotSearchQuery: string = '';
  lotView: string = 'all';

  importLots: boolean = false;

  exportValid: boolean = false;
  exportDate: string | null = null;
  exportAllDate: string | null = null;
  exportBidDate: string | null = null;
  exportBidderDate: string | null = null;
  exportTemplate: string = '/auction_csvs/';
  exportApiBase: string = apiBase ? apiBase : window.location.origin;
  exportUrlBase: string = `${this.exportApiBase}${apiNamespace}`;
  exportTemplates: Array<{ label: string; endpoint: string; type: string }> = [
    { label: 'All data', endpoint: '/auction_csvs/', type: 'all' },
    { label: 'Purchaser Listing', endpoint: '/bidder_csvs/', type: 'bidder' },
    { label: 'Absentee Bids', endpoint: '/bid_csvs/', type: 'bid' },
  ];

  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredRule = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  nextFn: (() => void) | null = null;

  get windowSize() {
    return window.outerWidth;
  }

  get auctionId() {
    return this.$route.params.auctionId;
  }

  get lotHeaders() {
    return Lot.listHeaders();
  }

  get lotOptions() {
    return Lot.defaultOptions();
  }

  get lotScope() {
    const whereObj: { auction: string; has_images?: boolean } = {
      auction: this.auctionId,
    };

    if (this.lotView === 'images') {
      whereObj.has_images = true;
    } else if (this.lotView === 'no-images') {
      whereObj.has_images = false;
    }

    return () => Lot.where(whereObj);
  }

  openImage(url: string) {
    if (!url) {
      return;
    }
    window.open(url, '_blank');
  }

  deleteImage(media: Media) {
    if (!media || !this.auction) {
      return;
    }

    const index = this.auction.images.indexOf(media);
    if (index !== -1) {
      this.auction.images.splice(index, 1);
      this.mediaToDelete.push(media);
    }
  }

  restoreImage(media: Media) {
    if (!media || !this.auction) {
      return;
    }

    const index = this.mediaToDelete.indexOf(media);
    if (index !== -1) {
      this.mediaToDelete.splice(index, 1);
      this.auction.images.push(media);
    }
  }

  update() {
    (this.$refs.lotTable as AbstractTable).update();
  }

  back() {
    this.$router.back();
  }

  doLotSearch() {
    this.lotSearchQuery = this.lotSearch;
  }

  setView(view: string) {
    if (!view || this.lotView === view) {
      return;
    }

    this.lotView = view;
  }

  addLot(edit: boolean = false) {
    if (edit) {
      this.lotToEdit = this.selectedLots[0];
    } else {
      this.lotToEdit = null;
    }

    this.lotAddEdit = true;
  }

  confirmDeleteLot() {
    this.lotConfirmDialog = true;
  }

  lotSaved() {
    this.lotAddEdit = false;
    snackModule.showSnackbar('Lot Saved');
    this.update();
  }

  lotClosed() {
    this.lotAddEdit = false;
  }

  lotClicked(item: Lot) {
    if (!item) {
      return;
    }

    this.lotToEdit = item;
    this.lotAddEdit = true;
  }

  updateExportDate() {
    const template = this.exportTemplates.find(
      element => element.endpoint === this.exportTemplate,
    );

    if (!template) {
      return;
    }

    switch (template.type) {
      case 'all':
        this.exportDate = this.exportAllDate;
        break;
      case 'bid':
        this.exportDate = this.exportBidDate;
        break;
      case 'bidder':
        this.exportDate = this.exportBidderDate;
        break;
    }
  }

  async doExport() {
    if (!this.exportDate) {
      return;
    }
    const url = new URL(
      this.exportUrlBase + this.exportTemplate + this.auctionId,
    );
    url.searchParams.set('since', this.exportDate);
    try {
      const r = await axios.get(url.href, {
        headers: {
          'X-CSRFTOKEN': Cookies.get('csrftoken'),
        },
      });
      const blob = new Blob([r.data], { type: 'text/csv' });
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download =
        'export-' + moment(this.exportDate).format('D-MM-YYYY') + '.csv';
      a.click();
      window.URL.revokeObjectURL(blobUrl);

      this.getExportDate();
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async getExportDate() {
    const template = this.exportTemplates.find(
      element => element.endpoint === this.exportTemplate,
    );

    if (!template) {
      return;
    }

    try {
      const scope = await Auction.find(this.$route.params.auctionId);
      const auction = scope.data;

      switch (template.type) {
        case 'all':
          this.exportAllDate = auction.lastExport;
          this.exportDate = this.exportAllDate;
          break;
        case 'bid':
          this.exportBidDate = auction.lastBidExport;
          this.exportDate = this.exportBidDate;
          break;
        case 'bidder':
          this.exportBidderDate = auction.lastBidderExport;
          this.exportDate = this.exportBidderDate;
          break;
      }
    } catch (err) {
      // Error
    }
  }

  async updateNumber(lot: Lot, event: Event) {
    lot.number = (event.target as HTMLInputElement).value;

    try {
      await lot.save({ with: ['auction.id', 'images.id'] });
    } catch (e) {
      // Error
    }
  }

  async updateNumberPreview(lot: Lot, event: Event) {
    lot.numberPreview = (event.target as HTMLInputElement).value;

    try {
      await lot.save({ with: ['auction.id', 'images.id'] });
    } catch (e) {
      // Error
    }
  }

  formatDateTime(date: string) {
    return moment(date).format('MMM D, YYYY h:mm a');
  }

  async addMedia(mediaId: number) {
    if (!mediaId || !this.auction) {
      return;
    }

    try {
      const media = (await Media.find(mediaId)).data;
      this.auction.images.push(media);
    } catch (e) {
      // Not found
    }
  }

  async deleteSelectedLot() {
    if (!this.selectedLots) {
      return;
    }
    try {
      await Promise.all(this.selectedLots.map(item => item.destroy()));
    } catch (err) {
      // Error
    } finally {
      this.lotConfirmDialog = false;
      this.selectedLots = [];
      this.update();
    }
  }

  async deleteMedia(media: Media) {
    if (!media) {
      return;
    }

    try {
      await media.destroy();
    } catch (e) {
      // Error
    }
  }

  async save() {
    if (!this.auction) {
      return;
    }

    if (this.auctionPublic) {
      if (!this.auction.published) {
        this.auction.published = moment().toISOString();
      }
    } else {
      this.auction.published = null;
    }

    if (this.mediaToDelete) {
      this.mediaToDelete.forEach(media => {
        this.deleteMedia(media);
      });
    }

    try {
      await this.auction.save({ with: ['images.id'] });
      if (
        this.$route.name === 'admin-auctions-add' &&
        this.auction &&
        this.auction.id
      ) {
        this.$router.push({
          name: 'admin-auctions-edit',
          params: { auctionId: this.auction.id },
        });
        snackModule.showSnackbar('Auction Published');
      } else {
        this.mediaToDelete = [];
        snackModule.showSnackbar('Auction Saved');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    } finally {
      this.auction.reset();
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: () => void) {
    if (
      (this.auction &&
        (this.auction.isDirty() || this.auction.isDirty('images'))) ||
      this.mediaToDelete.length > 0
    ) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async mounted() {
    if (
      this.$route.name === 'admin-auctions-edit' &&
      this.$route.params.auctionId
    ) {
      try {
        const scope = await Auction.includes(['images']).find(
          this.$route.params.auctionId,
        );
        this.auction = scope.data;

        if (!this.auction.published) {
          this.auctionPublic = false;
        }

        if (this.auction.lastExport) {
          this.exportAllDate = this.auction.lastExport;
        } else {
          this.exportAllDate = this.auction.created;
        }

        if (this.auction.lastBidExport) {
          this.exportBidDate = this.auction.lastBidExport;
        } else {
          this.exportBidDate = this.auction.created;
        }

        if (this.auction.lastBidderExport) {
          this.exportBidderDate = this.auction.lastBidderExport;
        } else {
          this.exportBidderDate = this.auction.created;
        }

        this.exportDate = this.exportAllDate;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Probably not found');
      }
    } else {
      this.auction = new Auction();
    }
  }

  @Watch('lotScope')
  @Watch('lotSearchQuery')
  lotScopeChanged() {
    setTimeout(this.update, 300);
  }
}
